<script setup>
import { defineProps, defineEmits, watch, computed, ref } from 'vue';
import usetablePageNation from "@/utils/hooks/usetablePageNation" //分页hooks
import { getDashboardIndex_standard_production_line,
    getDashboardIndex_standard_testing_company,
getDashboardIndex_standard_company
 } from "@/service/apiList/dashboard"
const props = defineProps({
    visible: {
        type: Boolean,
        required: true,
        default: false
    },
    dailogInfo: {
        type: Object,
        required: true,
        default: () => ({})
    },
})
const emits = defineEmits(['update:visible',])
const info = ref({})
const dailogInfostr = computed(() => JSON.stringify(props.dailogInfo))
const handleClose = () => {
    emits('update:visible', false);
}
const pageSizeOption = [10, 20, 30, 40, 50]
// 设置数据
const tableData = ref([])
// const allData = ref([])
// const currentPage = ref(1)
// const pageSize = ref(5)
const { total, currentPage, pageSize, pageOption } = usetablePageNation()

// const setTable = () => {
//     // 设置分页
//     let startIndex = ((currentPage.value - 1) * pageSize.value) - 1 < 0 ? 0 : ((currentPage.value - 1) * pageSize.value);
//     let endIndex = startIndex + pageSize.value;
//     total.value = info.value.list.length
//     tableData.value = info.value.list.slice(startIndex, endIndex)
// }

const getDataList = async () => {
    /**
     * ? 根据type 查询不同的数据
     */
    let params = {
        category_id: props.dailogInfo.category_id,
        page: currentPage.value -1,
        limit: pageSize.value,
        hscode_id: props.dailogInfo.hscode
    }
    let resp = {}
    if (props.dailogInfo.type == 0) {
        resp = await getDashboardIndex_standard_production_line(params)
    } else if (props.dailogInfo.type == 1) {
        resp = await getDashboardIndex_standard_testing_company(params)
    } else {
        resp = await getDashboardIndex_standard_company(params)
    }
    total.value = resp.payload.total
    tableData.value = resp.payload.data
}

watch(currentPage, () => {
    getDataList()
})
watch(pageSize, () => {
    currentPage.value = 1
    getDataList()
})

watch(dailogInfostr, () => {
    info.value = { ...props.dailogInfo }
    currentPage.value = 1
    getDataList()
}, { deep: true, immediate: true })
</script>
<template>
    <div class="modal fade show" style="display: block">
        <div class="modal-dialog modal-dialog-centered" style="max-width: 1000px !important;">
            <div class="modal-content my-dialog">
                <!-- head -->
                <div class="modal-header d-flex align-items-center p-2" style="border-bottom: 1px solid #E9EBEC;">
                    <h5 class="modal-title">{{ props.dailogInfo.title }}</h5>
                    <i class="ri-close-line btn-close cursor-pointer" @click="handleClose()"
                        style="color: white;background: unset; font-size: 26px; width: unset; height: unset;"></i>
                </div>
                <div class="modal-body text-center my-scroll-bar" style="max-height: 600px; overflow-y: auto;">
                    <div class="d-flex">
                        <div v-for="(head, k) in dailogInfo.header" :key="k" :style="{ flex: k == 0 ? 1 : 2 }"
                            style="text-align: left;color: #212529; font-size: 14px;">
                            {{ head.label }}
                        </div>
                    </div>
                    <div class="d-flex my-3" v-for="(data, kk) in tableData" :key="kk">
                        <div v-for="(head, k) in info.header" :key="k" :style="{ flex: k == 0 ? 1 : 2 }"
                            style="text-align: left;color: #212529;">
                            {{ head.key == 'index' ? kk + 1 : data[head.key]? data[head.key]: data.user? data.user[head.key]: '-' }}
                        </div>
                    </div>
                    <!-- 分页 -->
                    <Pagination v-if="total" v-model:page="currentPage" v-model:perPage="pageSize" :pages="pageOption"
                        :prePageOption="pageSizeOption" :showPageSelect="true" :showJump="true" :tab_info_length="total"
                        class="me-5 my-3 my-pagination">
                    </Pagination>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade show"></div>
</template>
<style scoped lang="scss">
.my-dialog {
    border: unset;
    // background-color: #9599AD;
    // :deep(.modal-content) {
    //     border: unset;
    // }

    .modal-header {
        background-color: #4A6372;
        color: white;
    }

    .modal-title {
        color: white;
    }
}
</style>